import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { supportedLanguages } from '../../i18n/config'

const { Option } = Select

const LanguageSwitcher = () => {
  const { i18n } = useTranslation()

  const handleChange = (value: string) => {
    i18n.changeLanguage(value)
  }

  return (
    <Select
      value={i18n.language}
      onChange={handleChange}
      className="min-w-[120px]"
      size="small"
    >
      {supportedLanguages.map((lang) => (
        <Option key={lang.code} value={lang.code}>
          <span className="mr-2">{lang.flag}</span>
          {lang.name}
        </Option>
      ))}
    </Select>
  )
}

export default LanguageSwitcher